export default "__VITE_ASSET__j2iLG8YV__"